import React, { forwardRef, useContext } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { EqualHeightElement } from "../EqualHeight/EqualHeightElement";
import { EqualHeightContext } from "../EqualHeight/EqualHeightContext";
import { Image, ImagePropTypes } from "../Image";

import styles from "./ProductTile.scss";

const ProductTilePicture = forwardRef(
  ({ src, alt, placeholder, customClass, imgProps, ...restProps }, ref) => {
    const { forceUpdateSize, setForceUpdateSize } = useContext(
      EqualHeightContext
    );

    const handleImageLoaded = () => {
      setForceUpdateSize(!forceUpdateSize);
    };

    return (
      <EqualHeightElement name="ProductTilePicture" placeholder={placeholder}>
        <div
          ref={ref}
          className={cx(styles.pictureWrapper, customClass)}
          {...restProps}
        >
          <Image
            src={src}
            alt={alt}
            className={styles.picture}
            onLoad={handleImageLoaded}
            {...imgProps}
          />
        </div>
      </EqualHeightElement>
    );
  }
);

ProductTilePicture.displayName = "ProductTile.Picture";

ProductTilePicture.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  placeholder: EqualHeightElement.propTypes.placeholder,
  customClass: PropTypes.string,
  imgProps: PropTypes.shape(ImagePropTypes),
};

ProductTilePicture.defaultProps = {
  placeholder: EqualHeightElement.defaultProps.placeholder,
  customClass: undefined,
  imgProps: undefined,
};

export default ProductTilePicture;
